<template>
<div class="container">
    <div class="logisticstop">
        <div class="list">
            <div class="express">
                <div class="expressleft">
                    <span class="express-company">快递公司：{{logisticsDetails.expName}}</span>
                    <span></span>
                </div>
                <div class="expressleft">
                    <span class="express-company">快递单号：{{logisticsDetails.number}}</span>
                    <span></span>
                </div>
                <div class="expressleft">
                    <span class="express-company" v-if="logisticsDetails.deliveryRemark && logisticsDetails.deliveryRemark!=''">物流备注：{{logisticsDetails.deliveryRemark}}</span>
                    <span></span>
                </div>
            </div>
        </div>
    </div>
    <div class="logisticsmiddle">
        <div class="details">物流详情</div>
    </div>
    <!-- 物流信息流转部分 -->
     <div class="logisticsbottom" v-if="!show">
        <div class="noinfo">暂无物流信息</div>
    </div>
    <div class="logisticsbottom" v-else>
        <van-steps direction="vertical" :active="0" active-color="#2283E2">
            <van-step v-for="(item,index) in logisticsDetails.list" :key="index">
                <h3>{{item.status}}</h3>
                <p>{{item.time}} {{item.context}}</p>
            </van-step>
        </van-steps>
    </div>
</div>
</template>

<script>
import {
    getLogisticsDetails,haierOrderBale
} from "@/api/api";
export default {
    data() {
        return {
            logisticsNo: "",
            logisticsDetails: {expName:null,number:null,list:null,deliveryRemark:null},
            show:true
        };
    },

    methods: {
        //获取物流信息
        async getLogistics(logisticsNo) {
            // var str = this.$cookies.get("memberPhone") || sessionStorage.getItem('memberPhone'); //截取后4位
            // console.log(cookies.get("memberPhone") || sessionStorage.getItem('memberPhone'))
            // console.log(this.$cookies.get("memberId") || this.sessionStorage.getItem('memberId'))
            // this.menber = str.substring(str.length - 4);
            let params = {
                logisticsCode: logisticsNo,
            };
            const logisticsS = await haierOrderBale({orderNo:this.$route.query.orderno});
           if (logisticsS.code==='0000') {
                this.logisticsDetails.expName = logisticsS.data.orderBaleDelivery.deliveryCompanyName
                this.logisticsDetails.number = logisticsS.data.orderBaleDelivery.expressNo
                this.logisticsDetails.deliveryRemark = logisticsS.data.orderBaleDelivery.deliveryRemark

           }
            const logistics = await getLogisticsDetails(params);
            if (logistics.code==='0000') {
                console.log(1111)
                this.logisticsDetails.list = logistics.result.records;
            }else{
                 this.show=false

            }
        },
    },
    mounted() {
        // 获取订单页面传来的订单信息,请求对应的物流数据
        this.logisticsNo = this.$route.query.logisticsNo;
        this.getLogistics(this.logisticsNo);
    },
};
</script>

<style lang="scss" scoped>
h3{
    font-weight: 100;
}
/deep/.van-step--vertical{
    padding: 0;
}
.container {
    .logisticstop {
        margin: 30px auto;
        width: 710px;
        // height: 240px;
        background: #ffffff;
        border-radius: 14px;

        .list {
            display: flex;
            padding: 30px 50px;

            .commodity {
                width: 180px;
                height: 180px;
                position: relative;

                img {
                    width: 100%;
                    border-radius: 14px;
                }

                span {
                    width: 100%;
                    display: block;
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%, -0%);
                    padding: 12px 0;
                    text-align: center;
                    opacity: 0.5;
                    background: #000000;
                    border-radius: 0px 0px 14px 14px;
                    color: #fff;
                }
            }

            .express {
                margin-left: 30px;
                margin-top: 30px;

                .expressleft {
                    display: flex;
                    margin-bottom: 10px;

                    .express-company {
                        color: #333;
                    }

                    span {
                        display: block;
                        font-size: 28px;
                        color: #999999;
                    }
                }
            }
        }
    }

    .logisticsmiddle {
        background-color: #ffffff;
        padding: 30px;
        border-bottom: 1px solid #efefef;

        .details {
            font-size: 30px;
            font-weight: 400;
            text-align: left;
            color: #999999;
            line-height: 30px;
        }
    }

    .logisticsbottom {
        background-color: #fff;
        padding-bottom: 40px;

        .details-list {
            width: 80%;
            margin: 0 auto;
            padding: 30px 0;

            .my-icon {
                font-family: "my-icon";
                src: url("../../../assets/icon/dian.png") format("truetype");
            }

            .my-icon-extra::before {
                content: "\e626";
            }

            a {
                display: block;
                color: #333;
                font-size: 24px;
                text-align: center;
            }

            .details-h3 {
                font-size: 28px;
                font-weight: 500;
                text-align: left;
                line-height: 38px;
                padding-bottom: 12px;
            }

            .details-p {
                font-size: 24px;
                font-weight: 400;
                text-align: left;
                line-height: 24px;
            }
        }
    }
}
.noinfo{
    text-align: center;
    font-size: 28px;
    padding: 20px;
}
</style>
